"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
/**
 * Basic component providing single line text input
 */

var Input = React.forwardRef(function (_ref, ref) {
  var _cx;

  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Value' : _ref$placeholder,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'default' : _ref$kind,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "type", "placeholder", "kind", "disabled"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("input", (0, _extends2["default"])({}, rest, {
    ref: ref,
    type: type,
    placeholder: placeholder,
    disabled: disabled,
    className: (0, _classnames["default"])(classes.Input, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.Light, kind === 'light'), (0, _defineProperty2["default"])(_cx, classes.Disabled, disabled), (0, _defineProperty2["default"])(_cx, classes.Error, rest['data-has-errors']), (0, _defineProperty2["default"])(_cx, classes.Warning, rest['data-has-warnings']), _cx), className)
  }));
});
exports["default"] = Input;
Input.displayName = 'Input';
//# sourceMappingURL=index.js.map